import React from 'react';

import Gallery from '../gallery/Gallery';

const HomePortfolio = () => {
    return (
        <section id="porfolio" className="block spacer p-top-xl">
            <div className="wrapper">
                <div className="title">
                    <h2>Our Portfolio</h2>
                </div>

                <div className="description max-width-2">
                    <p>Explore our diverse portfolio showcasing a blend of stunning landscapes, captivating portraits, and dynamic event photography. Each photograph tells a unique story, meticulously crafted to perfection.</p>
                </div>

                <div className="spacer p-top-lg">
                    <Gallery />
                </div>
            </div>
        </section>
    );
};

export default HomePortfolio;
